import { render, staticRenderFns } from "./BrandPopup.vue?vue&type=template&id=e2dbf250&scoped=true&"
import script from "./BrandPopup.vue?vue&type=script&lang=js&"
export * from "./BrandPopup.vue?vue&type=script&lang=js&"
import style0 from "./BrandPopup.vue?vue&type=style&index=0&id=e2dbf250&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2dbf250",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1771009219/src/capas-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e2dbf250')) {
      api.createRecord('e2dbf250', component.options)
    } else {
      api.reload('e2dbf250', component.options)
    }
    module.hot.accept("./BrandPopup.vue?vue&type=template&id=e2dbf250&scoped=true&", function () {
      api.rerender('e2dbf250', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SAdmin/BrandPopup.vue"
export default component.exports